module.exports = __webpack_public_path__ + "static/media/IUP_ok.c2041c55.svg";